/* istanbul ignore file */
export const ptom = (px: number): string => process.env.STORYBOOK === 'true'
  ? px + 'px'
  : String(px * 297 / 1613) + 'mm';
export default ptom;
